// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"d8bb2b1f4eeab8f50472","1642":"a118a4db4cfaa015f956","4057":"a53adba637d509768ab9","5771":"d141d1ad8187d99738b9","7471":"6423b9b898ffefeb7d1d"}[chunkId] + "";
};